import DataStorePlaync from '../_dataStore/dataStorePlaync';

class FooterGlobal {
    constructor(){
		this.store = new DataStorePlaync({onComplete: this.setGlobalTemplate});

        this.addEvents();
	}

	setGlobalTemplate(areaDataConfig){
    	let countryLists = ``;
    	let languageLists = ``;
    	let snsLists = ``;
    	let footerLinks = ``;
    	let countryIndex;
		let familySiteLists = ``;

		console.log(areaDataConfig);

		for(let i=0; i<areaDataConfig.countryData.length;i++){
			if(areaDataConfig.countryData[i][0] === areaDataConfig.country){
				countryIndex = i;
			}
			countryLists += `
			<li class="footer-change-item">
				<a href="javascript: void(0)" class="change-item-link" data-country="${areaDataConfig.countryData[i][0]}">
					${
					areaDataConfig.countryData[i][0] === areaDataConfig.country ?
					`
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g fill="none" fill-opacity=".6" fill-rule="evenodd"><g fill="#FFF"><g><g><g><path d="M1.257 6.207L1.964 5.5 4.793 8.328 9.743 3.379 10.45 4.086 4.793 9.743z" transform="translate(-455.000000, -729.000000) translate(0.000000, 175.000000) translate(440.000000, 535.000000) translate(15.000000, 19.000000)"/></g></g></g></g></g></svg>
					<strong>${areaDataConfig.countryData[i][1]}</strong>
					` :
					`
					<span>${areaDataConfig.countryData[i][1]}</span>

					`
					}
				</a>
			</li>
			`
		}

		for(let language in areaDataConfig.languageData){
			languageLists += `
			<li class="footer-change-item">
				<a href="javascript: void(0)" class="change-item-link"  data-language="${language}">
					${
					areaDataConfig.languageData[language] === areaDataConfig.languageData[areaDataConfig.language] ?
					`
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g fill="none" fill-opacity=".6" fill-rule="evenodd"><g fill="#FFF"><g><g><g><path d="M1.257 6.207L1.964 5.5 4.793 8.328 9.743 3.379 10.45 4.086 4.793 9.743z" transform="translate(-455.000000, -729.000000) translate(0.000000, 175.000000) translate(440.000000, 535.000000) translate(15.000000, 19.000000)"/></g></g></g></g></g></svg>
					<strong>${areaDataConfig.languageData[language]}</strong>
					` :
					`
					<span>${areaDataConfig.languageData[language]}</span>

					`
					}
				</a>
			</li>
			`
		}

    	for(let sns in areaDataConfig.snsList){
    		snsLists += `
		   	<li class="footer-sns-items ${areaDataConfig.snsList[sns].class}">
				<a href="${areaDataConfig.snsList[sns].link}" target="${areaDataConfig.snsList[sns].target}">${areaDataConfig.snsList[sns].name}</a>
			</li>
    		`
		}

    	for (let menu in areaDataConfig.menu){
    		let tempLinkItem = ``;
    		if(areaDataConfig.menu[menu].isBold){
				tempLinkItem =
				`
				<li class="footer-links-items">
					<a href="${areaDataConfig.menu[menu].link}" target="${areaDataConfig.menu[menu].target}">
						<strong>${areaDataConfig.menu[menu].name}</strong>
					</a>
				</li>
				`
			}
    		else{
    			tempLinkItem =
				`
				<li class="footer-links-items">
					<a href="${areaDataConfig.menu[menu].link}" target="${areaDataConfig.menu[menu].target}">${areaDataConfig.menu[menu].name}</a>
				</li>
				`
			}
			footerLinks += tempLinkItem;
		}

		for(let site in areaDataConfig.familySites){
			console.log(site);

			familySiteLists += `
		   	<li class="footer-change-item">
				<a href="${areaDataConfig.familySites[site].link}" target="_blank" class="change-item-link"><span>${areaDataConfig.familySites[site].name}</span></a>
			</li>
    		`
		}

		let resultMarkupFooter = `
		<div class="footer footer-${areaDataConfig.serviceName}">
		
			<div class="footer-change-wrap">
				<div class="footer-change-inner footer-change-country">
<!--					<div class="footer-change-list-wrap" id="countryChangeWrapper">-->
<!--						-->
<!--					</div>-->
					<ul class="footer-change-list">
						${countryLists}
					</ul>
					<button class="btn-footer-change">
						<span class="inner-txt">${areaDataConfig.countryData[countryIndex][1]}</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-opacity=".38" fill-rule="evenodd"><g fill="#FFF"><g><g><g><g><path d="M12 9l-4 4-4-4h8zM8 3l4 4H4l4-4z" transform="translate(-373.000000, -970.000000) translate(0.000000, 175.000000) translate(100.000000, 535.000000) translate(0.000000, 246.000000) translate(273.000000, 14.000000)"/></g></g></g></g></g></g></svg>
					</button>
				</div>
				<div class="footer-change-inner footer-change-language">
					<button class="btn-footer-change">
						<span class="inner-txt">${areaDataConfig.languageData[areaDataConfig.language]}</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-opacity=".38" fill-rule="evenodd"><g fill="#FFF"><g><g><g><g><path d="M12 9l-4 4-4-4h8zM8 3l4 4H4l4-4z" transform="translate(-373.000000, -970.000000) translate(0.000000, 175.000000) translate(100.000000, 535.000000) translate(0.000000, 246.000000) translate(273.000000, 14.000000)"/></g></g></g></g></g></g></svg>
					</button>
					<ul class="footer-change-list">
						${languageLists}
					</ul>
				</div>
			</div>
			
	   		<div class="footer-sns">
	   			${ areaDataConfig.snsList.length > 0 ?
				`<ul class="footer-sns-list footer-sns-list-kr">
				${snsLists}
				</ul>` :
				``
				}
			</div>
			
			<div class="footer-links">
				<ul class="footer-links-list footer-links-list-kr">
				${footerLinks}
				</ul>
			</div>
		
			<div class="footer-copyright">
				<div class="footer-info">
					<div class="footer-info-address">${areaDataConfig.infoAddress} ${areaDataConfig.companyInfo}</div>
					<div class="footer-info-cs">${areaDataConfig.infoCS} <span class="span-rtl">${areaDataConfig.companyEmail}</span></div>
				</div>
				<div class="copyright-company">${areaDataConfig.copyrightCompany}</div>
				<div class="footer-logo-wrap">
					<a class="footer-logo ncsoft" href="${areaDataConfig.companyLink}" target="_blank">NCSOFT</a>
					${ areaDataConfig.country === 'KR' ? `<a class="footer-logo ncdinos" href="https://www.ncdinos.com/" target="_blank">NC DINOS</a>` : ``}
				</div>
			</div>
			
			<div class="footer-change-wrap footer-family-sites">
				<div class="footer-change-inner">
					<button class="btn-footer-change">
						<span class="inner-txt">Family Site</span>
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none" fill-opacity=".45" fill-rule="evenodd"><g fill="#000"><g><g><g><path d="M9 3v4h4v2H9v4H7V9H3V7h4V3h2z" transform="translate(-1304.000000, -337.000000) translate(1180.000000, 175.000000) translate(0.000000, 150.000000) translate(124.000000, 12.000000)"/></g></g></g></g></g></svg>					
					</button>
					<ul class="footer-change-list">
						${familySiteLists}
					</ul>
				</div>
			</div>
		</div>
		`;
  
		document.querySelector('#footer.wrap-footer').insertAdjacentHTML('beforeend', resultMarkupFooter);
	}
	
	addEvents(){

	}

} // end of class
export default FooterGlobal;
